import React,{ useEffect, useState } from "react";

// components
import { IToastVariables, ToastMessageType } from "@/components/elements/global/ToastNotification";

// interfaces
import { archiveItem } from "@/components/page/Archive";

// hooks and untils
import { getArchivedItemById, restoreArchivedCotent } from  "@/api/archiveContent";


const useRestoreContentFromPage = ({contentId, appId}: {contentId:string, appId: string}) => {
    
    const [archivedItem, setArchivedItem] = useState<archiveItem>();
    const [showToast, setShowToast] = useState<boolean>(false)
    const [toastVariables, setToastVariables] = useState<IToastVariables>({message: '', messageType: ToastMessageType.SUCCESS});
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [shouldRefresh, setShouldRefresh] = useState<boolean>(false);

   

    useEffect(() => {
        getArchivedItemById(Number(contentId)).then(item => {
            setArchivedItem(item)
        })
    }, [])

    useEffect(() => {
        if(shouldRefresh) {
            window.location.reload();
        }
        
    },[shouldRefresh])

    function restore(){
        
        setIsLoading(true)
          
        if(archivedItem) {
            restoreArchivedCotent(Number(appId), archivedItem)
            .then(() => {
                window.sessionStorage.setItem('toastOnLoad', JSON.stringify({
                    message: `Content item successfully restored`,
                    messageType: ToastMessageType.SUCCESS, 
                }))
                setShouldRefresh(true)
            })
            .catch(() => {
                setShowToast(true)
                setToastVariables({message: `Could not restore Content Item at this time`, messageType: ToastMessageType.ALERT})
            })
            .finally(() => {
                setIsLoading(false);
            })
        }
        
    }

    function handleToastMessageClose() {
        setShowToast(false);
    }

    return {showToast, toastVariables, isLoading, restore, handleToastMessageClose}
}

export default useRestoreContentFromPage